export interface ProjectLocation {
  name: string;
  lat: number;
  lon: number;
  region: string;
}

export interface ProjectConfig {
  farm_area_acres: number;
  panel_efficiency: 'high' | 'average' | 'old';
  inverter_loss: number;
  soiling_loss: number;
  temperature_derate: number;
}

export interface Project {
  id: string;
  name: string;
  location: ProjectLocation;
  config: ProjectConfig;
  description: string;
  developer: string;
  status: string;
  capacity_mw_peak: number;
  isDefault?: boolean;
}

export interface ProjectsData {
  projects: Project[];
  meta: {
    version: string;
    lastUpdated: string;
    note: string;
  };
}

let cachedProjects: ProjectsData | null = null;

export async function loadProjects(): Promise<ProjectsData> {
  if (cachedProjects) {
    return cachedProjects;
  }
  
  try {
    const response = await fetch('./data/projects.json');
    if (!response.ok) {
      throw new Error('Failed to load projects');
    }
    cachedProjects = await response.json();
    return cachedProjects!;
  } catch (error) {
    console.error('Error loading projects:', error);
    // Return default project if fetch fails
    return getDefaultProjectsData();
  }
}

export function getDefaultProjectsData(): ProjectsData {
  return {
    projects: [
      {
        id: 'east-pye',
        name: 'East Pye Solar Farm',
        location: {
          name: 'Hempnall, South Norfolk',
          lat: 52.50248,
          lon: 1.29835,
          region: 'East Anglia'
        },
        config: {
          farm_area_acres: 2700,
          panel_efficiency: 'average',
          inverter_loss: 0.03,
          soiling_loss: 0.02,
          temperature_derate: 0.004
        },
        description: 'Proposed 2,700-acre industrial solar farm in South Norfolk countryside',
        developer: 'Island Green Power',
        status: 'Proposed',
        capacity_mw_peak: 45,
        isDefault: true
      }
    ],
    meta: {
      version: '1.0',
      lastUpdated: '2025-12-16',
      note: 'UK Solar Project configurations'
    }
  };
}

export function getDefaultProject(): Project {
  const data = getDefaultProjectsData();
  return data.projects.find(p => p.isDefault) || data.projects[0];
}

